import { CardSuit } from "../card/Card";
import { TrumpSuit } from "../state/TableStateMachine";

export function TrumpSuitToCardSuit(cardSuit: TrumpSuit): CardSuit
{
    switch(cardSuit) {
        case TrumpSuit.CLUBS:
            return CardSuit.CLUBS;
        case TrumpSuit.DIAMONDS:
            return CardSuit.DIAMONDS;
        case TrumpSuit.HEARTS:
            return CardSuit.HEARTS;
        case TrumpSuit.SPADES:
            return CardSuit.SPADES;
        case TrumpSuit.NOTRUMPS:
        case TrumpSuit.ALLTRUMPS:
            return -1;
    }
    return -1;
}